// src/app/modules/campagnes/UsersListModal.jsx
import React, { useMemo, useState } from "react";
import "../../RessourcesStyles/CampagneManagement.css";
import '../../RessourcesStyles/UsersListModal.css'

const PAGE_SIZE = 15;
const norm = (v) => String(v ?? "").toLowerCase().trim();

const UsersListModal = (props) => {
    const {
        opened,
        closed,

        // props "comme ancien"
        filterMode,       // "IN" | "NOT_IN" ou "in"/"notin" (ne change PAS la liste affichée)
        managerlevel,     // "" | "n+1" | "n+2"
        entites = [],     // [ids]
        postes = [],      // [ids]

        liteusers = [],   // liste "light" (sert à trouver managers)
        users = [],       // liste complète avec checked
        setUsers,         // setUsers(updatedUsers)
        setSelectedUsers, // setSelectedUsers(users.filter(u.checked))
    } = props;

    const [pageNumber, setPageNumber] = useState(1);

    // ✅ comme ancien : 3 inputs
    const [matricule, setMatricule] = useState("");
    const [nom, setNom] = useState("");
    const [prenom, setPrenom] = useState("");

    const usersFilter = () => {
        // base sorted (comme ancien)
        let out = [...(users || [])].sort((a, b) => Number(a.id) - Number(b.id));

        // ✅ managerlevel logic (comme ancien)
        if (managerlevel && String(managerlevel).trim() !== "") {
            console.log("users:", users?.length, "liteusers:", liteusers?.length, "managerlevel:", managerlevel);

            switch (managerlevel) {
                case "n+1": {


                    // ancien: liteusers.map(lu => lu.managerId).includes(u.id)
                    const managerIds = (liteusers || [])
                        .map((lu) => Number(lu.managerId ?? lu.managerId))
                        .filter(Boolean);
                    console.log("managerIds count:", managerIds.length, "sample:", managerIds.slice(0, 10));
                    console.log("existing ids sample:", (users || []).slice(0, 10).map(u => u.id));
                    console.log("do we have id 9?", (users || []).some(u => Number(u.id) === 9));
                    console.log("do we have id 5001?", (users || []).some(u => Number(u.id) === 5001));

                    out = out.filter((u) => managerIds.includes(Number(u.id)));
                    break;

                }

                case "n+2": {
                    const managerIds = (liteusers || [])
                        .map((lu) => Number(lu.managerId ?? lu.managerId))
                        .filter(Boolean);

                    out = out.filter((u) => managerIds.includes(Number(u.id)));

                    const managerIds2 = out
                        .map((lu) => Number(lu.managerId ?? lu.managerId))
                        .filter(Boolean);

                    out = out.filter((u) => managerIds2.includes(Number(u.id)));
                    break;
                }
                default:
                    break;
            }
        }

        // ✅ entites/postes (comme ancien)
        if ((entites || []).length > 0) {
            const setEnt = new Set((entites || []).map((x) => Number(x)));
            out = out.filter((u) => setEnt.has(Number(u.entityId ?? u.entityId)));
        }

        if ((postes || []).length > 0) {
            const setPos = new Set((postes || []).map((x) => Number(x)));
            out = out.filter((u) => setPos.has(Number(u.jobId ?? u.jobId)));
        }

        /**
         * ✅ IMPORTANT : on NE FAIT PAS l’inversion NOT IN ici.
         * Tu veux exactement comme ancien :
         * - IN => afficher les users qui matchent les filtres
         * - NOT IN => afficher les users qui matchent les filtres (pour les exclure)
         */
        void filterMode; // juste pour éviter warning eslint "unused"

        // ✅ filtres texte (comme ancien)
        if (matricule.trim().length > 0) {
            const s = norm(matricule);
            out = out.filter((u) =>
                norm(u.employeeCode ?? u.matricule).includes(s)
            );
        }

        if (nom.trim().length > 0) {
            const s = norm(nom);
            out = out.filter((u) =>
                norm(u.lastName ?? u.nom).includes(s)
            );
        }

        if (prenom.trim().length > 0) {
            const s = norm(prenom);
            out = out.filter((u) =>
                norm(u.firstName ?? u.prenom).includes(s)
            );
        }

        return out;
    };

    const filtered = useMemo(
        () => usersFilter(),
        [users, liteusers, entites, postes, managerlevel, filterMode, matricule, nom, prenom]
    );

    const selectedUsersCount = useMemo(
        () => (users || []).filter((u) => u.checked).length,
        [users]
    );

    const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
    const safePage = Math.min(pageNumber, totalPages);

    const pageRows = useMemo(() => {
        const start = (safePage - 1) * PAGE_SIZE;
        return filtered.slice(start, start + PAGE_SIZE);
    }, [filtered, safePage]);

    // ✅ Toggle EXACT comme ancien : update l'user + merge dans users complet
    const toggleChecked = (uid) => {
        const id = Number(uid);

        const current = (users || []).find((u) => Number(u.id) === id);
        if (!current) return;

        const updatedUser = { ...current, checked: !current.checked };

        const updatedUsers = [
            ...(users || []).filter((u) => Number(u.id) !== id),
            updatedUser,
        ].sort((a, b) => Number(a.id) - Number(b.id));

        setUsers?.(updatedUsers);
    };

    if (!opened) return null;

    return (
        <div className="modalOverlay" onMouseDown={closed}>
            <div className="modalCard" onMouseDown={(e) => e.stopPropagation()}>
                <div className="modalHeader">
                    <div>
                        <div className="modalTitle">Liste des utilisateurs</div>
                        <div className="modalSubTitle">
                            {selectedUsersCount} sélectionné(s)
                        </div>
                    </div>
                    <button className="btn btn-light" onClick={closed} type="button">
                        ✕
                    </button>
                </div>

                <div className="modalBody">
                    {/* ✅ 3 filtres comme ancien */}
                    <div className="campagne-grid-3">
                        <div className="field">
                            <label>Matricule</label>
                            <input
                                value={matricule}
                                onChange={(e) => {
                                    setMatricule(e.target.value);
                                    setPageNumber(1);
                                }}
                                placeholder="Matricule..."
                            />
                        </div>

                        <div className="field">
                            <label>Nom</label>
                            <input
                                value={nom}
                                onChange={(e) => {
                                    setNom(e.target.value);
                                    setPageNumber(1);
                                }}
                                placeholder="Nom..."
                            />
                        </div>

                        <div className="field">
                            <label>Prénom</label>
                            <input
                                value={prenom}
                                onChange={(e) => {
                                    setPrenom(e.target.value);
                                    setPageNumber(1);
                                }}
                                placeholder="Prénom..."
                            />
                        </div>
                    </div>

                    <div className="tableWrap mt12">
                        <table className="table">
                            <thead>
                            <tr>
                                <th style={{ width: 110 }}>Matricule</th>
                                <th>Nom</th>
                                <th>Prénom</th>
                                <th>Entité</th>
                                <th>Poste</th>
                                <th style={{ width: 120, textAlign: "center" }}>
                                    Sélectionner
                                </th>
                            </tr>
                            </thead>

                            <tbody>
                            {pageRows.map((u) => (
                                <tr key={u.id}>
                                    <td>{u.employeeCode ?? u.matricule ?? "-"}</td>
                                    <td>{u.lastName ?? u.nom ?? "-"}</td>
                                    <td>{u.firstName ?? u.prenom ?? "-"}</td>
                                    <td>{u.entityName ?? u.entite_nom ?? "-"}</td>
                                    <td>{u.jobName ?? u.poste_nom ?? "-"}</td>
                                    <td style={{ textAlign: "center" }}>
                                        <input
                                            type="checkbox"
                                            checked={!!u.checked}
                                            onChange={() => toggleChecked(u.id)}
                                        />
                                    </td>
                                </tr>
                            ))}

                            {!pageRows.length && (
                                <tr>
                                    <td colSpan={6} style={{ textAlign: "center", padding: 18 }}>
                                        Aucun utilisateur
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>

                    <div className="paginationRow">
                        <button
                            className="btn btn-light"
                            disabled={safePage <= 1}
                            onClick={() => setPageNumber((p) => Math.max(1, p - 1))}
                            type="button"
                        >
                            {"<"}
                        </button>

                        <div className="muted">
                            Page {safePage} / {totalPages}
                        </div>

                        <button
                            className="btn btn-light"
                            disabled={safePage >= totalPages}
                            onClick={() => setPageNumber((p) => Math.min(totalPages, p + 1))}
                            type="button"
                        >
                            {">"}
                        </button>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 10,
                            marginTop: 14,
                        }}
                    >
                        <button className="btn btn-secondary" type="button" onClick={closed}>
                            Fermer
                        </button>

                        <button
                            className="btn btn-primary"
                            type="button"
                            onClick={() => {
                                setSelectedUsers?.((users || []).filter((u) => u.checked));
                                closed?.();
                            }}
                        >
                            Enregistrer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UsersListModal;
